import PreviewPlayButton from '#/components/Form/PreviewPlayButton/PreviewPlayButton';
import useDeviceId from '#/hooks/useDeviceId';
import useProtectedSpotify from '#/hooks/useProtectedAxios';
import ApiManager from '#/services/api/ApiManager';
import { spotifyApiConfig } from '#/utils/constants';
import React, {
  HTMLAttributes,
  ImgHTMLAttributes,
  MouseEvent,
  useState,
} from 'react';

interface IProperties {
  image?: ImgHTMLAttributes<HTMLImageElement>['src'];
  name?: string;
  loading?: boolean;
  onClick?: HTMLAttributes<HTMLDivElement>['onClick'];
  uri?: string;
}

const ArtistPreview = (properties: IProperties) => {
  const { image, name, loading, onClick, uri } = properties;

  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => setHover(true);

  const handleMouseLeave = () => setHover(false);

  const protectedSpotify = useProtectedSpotify();

  const { retrieveDeviceId } = useDeviceId();

  const handleClickPlay = async (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    const apiManager = new ApiManager(spotifyApiConfig, protectedSpotify);

    const response = await apiManager.replaceEntity(
      'playerPlay',
      '',
      {
        context_uri: uri,
      },
      {
        device_id: retrieveDeviceId(),
      }
    );
    if ('error' in response) {
      // TODO: handle error
      // eslint-disable-next-line no-console
      console.log('Cant reproduce');
    }
  };

  return (
    <div
      className=" aspect-[195/272] p-4 bg-theme-dark-gray rounded-md shadow-theme-darker-gray shadow-lg transition-colors duration-300 hover:cursor-pointer hover:bg-theme-gray"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={onClick}
    >
      {loading ? (
        <>
          <div className=" w-full aspect-square rounded-full shadow-theme-darker-gray shadow-xl mb-4 bg-theme-gray animate-pulse" />
          <div className=" w-5/6 rounded-full h-6 mb-1 animate-pulse bg-theme-gray" />
          <div className=" w-2/3 rounded-full h-5 animate-pulse bg-theme-gray" />
        </>
      ) : (
        <>
          <div className="relative aspect-square mb-4">
            <img
              className=" h-full w-full rounded-full object-cover shadow-theme-darker-gray shadow-xl"
              src={image}
              alt=""
              loading="lazy"
            />
            <PreviewPlayButton onClick={handleClickPlay} hover={hover} />
          </div>
          <span className="block text-theme-white font-bold pb-1 one-line-text">
            {name}
          </span>
          <span className="text-sm text-theme-light-gray">Artist</span>
        </>
      )}
    </div>
  );
};

export default ArtistPreview;
